import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle, Home } from 'lucide-react';
import { t } from '../locales/nl';

const ConfirmationPage: React.FC = () => {
  // Scroll to top on component mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-neutral-50 flex items-center justify-center">
      <div className="page-container text-center py-10 fade-in">
        <div className="rounded-full bg-green-100 p-4 w-20 h-20 flex items-center justify-center mx-auto mb-6">
          <CheckCircle size={40} className="text-green-600" />
        </div>
        
        <h1 className="text-2xl font-bold mb-2">{t.confirmationTitle}</h1>
        <p className="text-neutral-600 mb-8">
          {t.confirmationMessage}
        </p>
        
        <Link to="/" className="btn btn-primary inline-flex items-center">
          <Home size={18} className="mr-2" />
          {t.backToHome}
        </Link>
      </div>
    </div>
  );
};

export default ConfirmationPage;